export default () => ({
    selectedValidationProject: null,
    selectedValidationDevice: null,
    selectedEvent:null,
    validationData:[],
    validationTableHeaderData: {
        activeSorted: {
            field: '',
            order: ''
        },
        activeFilterField: '',
        filters: {eventAt: null, eventEnd: null, coreIndicators: [], severityRating: null, operator: null, /*speed: null, petValue: null, eventType: null, eventClass: null,*/ eventValid: null}
    },
    searchQueryData: {
        query: '',
        sort: {icon: 'sort-alphabetical-ascending', text: 'Alphabetically ascending', value: 'ASCENDING'},
        projectType: {icon: '', text: 'All', value: 'ALL'},
        active: {icon: 'calendar-check', text: 'Active', value: 'Active'},
    }
});
